var webooker_schedule_models = webooker_schedule_models || {};

(function (ns) {

    ns.UserScheduleDetailWaitQueueItem = function (userScheduleDetailWaitQueueItemDto, userScheduleDetail) {
        this.dto = userScheduleDetailWaitQueueItemDto;
        this.userScheduleDetail = userScheduleDetail;

        this.compensationWaitQueueID = userScheduleDetailWaitQueueItemDto.compensationWaitQueueID;
        this.studentID = userScheduleDetailWaitQueueItemDto.studentID;
    }

})(webooker_schedule_models);